import { GET_CONTACT } from "../ConstAction";

export const contact = (data) => {
  console.log(data);
  
  return {
    type: GET_CONTACT,
    data: data,
    loading: true
  };
};

